module.exports = __webpack_public_path__ + "img/loading.15e36e57.gif";